import {ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {orangeColors} from '../../../../../layouts/theme/designSystem';

export interface Props {
  title: string;
  description?: string;
  children: ReactNode;
  fillHeight?: boolean;
}

export const WorkforceDashboardSectionCard = ({title, description, children, fillHeight}: Props) => {
  return (
    <EmpionPaper
      sx={{
        border: `1px solid ${orangeColors[3]}`,
        borderRadius: '14px',
        p: 2,
        ...(fillHeight && {height: '100%', display: 'flex', flexDirection: 'column'}),
      }}
    >
      <Typography variant='h6' sx={{mb: description ? 0.5 : 1.5}}>
        {title}
      </Typography>
      {description && (
        <Typography variant='body2' sx={{color: 'text.secondary', mb: 1.5}}>
          {description}
        </Typography>
      )}
      <Box sx={{minWidth: 0, ...(fillHeight && {flex: 1, display: 'flex', flexDirection: 'column'})}}>
        {children}
      </Box>
    </EmpionPaper>
  );
};
